"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _useKeyListener = _interopRequireDefault(require("../hooks/useKeyListener"));
var _styles = require("./styles");
var _useFocusTrap2 = _interopRequireDefault(require("../hooks/useFocusTrap"));
var _excluded = ["children", "headerChildren", "closeButton", "withPadding", "onClose", "closeOnOverlayClick", "size", "width", "height"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function Modal(_ref) {
  var children = _ref.children,
    headerChildren = _ref.headerChildren,
    CloseButton = _ref.closeButton,
    withPadding = _ref.withPadding,
    onClose = _ref.onClose,
    closeOnOverlayClick = _ref.closeOnOverlayClick,
    size = _ref.size,
    width = _ref.width,
    height = _ref.height,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var overlayRef = (0, _react.useRef)(null);
  var handleOverlayClick = (0, _react.useCallback)(function (e) {
    if (closeOnOverlayClick && e.target === overlayRef.current) {
      onClose(e);
    }
  }, [onClose, closeOnOverlayClick, overlayRef]);

  // 'Esc' for IE, of course
  (0, _useKeyListener["default"])(['Escape', 'Esc'], onClose);
  var _useFocusTrap = (0, _useFocusTrap2["default"])(),
    setModalRef = _useFocusTrap.setTarget;
  return /*#__PURE__*/_react["default"].createElement(_styles.OverlayWrapper, (0, _extends2["default"])({}, rest, {
    ref: overlayRef,
    onClick: handleOverlayClick
  }), /*#__PURE__*/_react["default"].createElement(_styles.ModalBody, {
    size: size,
    width: width,
    height: height,
    role: "dialog",
    ref: setModalRef
  }, headerChildren, /*#__PURE__*/_react["default"].createElement(_styles.ContentWrapper, {
    withPadding: withPadding
  }, children)));
}
Modal.propTypes = {
  onClose: _propTypes["default"].func,
  closeOnOverlayClick: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  headerChildren: _propTypes["default"].node,
  closeButton: _propTypes["default"].func,
  withPadding: _propTypes["default"].bool,
  /** If 'custom', won't apply any size styling */
  size: _propTypes["default"].oneOf(['sm', 'md', 'lg', 'xl', 'custom']),
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
Modal.defaultProps = {
  onClose: _noop["default"],
  closeOnOverlayClick: true,
  className: '',
  children: null,
  headerChildren: null,
  closeButton: null,
  // TODO: default this to false.
  // this is the exact opposite of ModalWithHeader's default styling
  withPadding: true,
  size: 'md',
  width: undefined,
  height: undefined
};
var _default = Modal;
exports["default"] = _default;
//# sourceMappingURL=Modal.js.map